import { Link } from 'react-router-dom';

const TOOL_ITEMS = [
  {
    image: '/images/tools/intekenen.png',
    title: 'Demarcatiegebied intekenen',
    link: '/intekenen',
    tag: 'Tools',
  },
  {
    image: '/images/tools/projecten.png',
    title: 'Mijn projecten',
    link: '/projects',
    tag: 'Tools',
  },
  {
    image: '/images/tools/trace-studie.png',
    title: 'Tracé studie aanvragen',
    link: '/projects',
    tag: 'Tools',
  },
];

function PortfolioSection() {
  return (
    <section className="page-section page-section--tools" id="portfolio">
      <div className="container-1280">
        <h2 className="section-heading">Tools</h2>

        <div className="c-cards">
          <div className="c-cards__list">
            {TOOL_ITEMS.map((item) => (
              <article key={item.title} className="c-card__item">
                <Link to={item.link} className="c-card__link">
                  <div className="c-card__image">
                    <div className="c-card__tag">
                      <div className="c-tag">
                        <span className="c-tag__name">{item.tag}</span>
                      </div>
                    </div>
                    <img className="c-card__img" src={item.image} alt={item.title} loading="lazy" />
                  </div>
                  <div className="c-card__contents">
                    <h3 className="c-card__title">{item.title}</h3>
                  </div>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default PortfolioSection;
